import { TimeUnit } from 'chart.js';

export const longFormatter = new Intl.DateTimeFormat(undefined, {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
});

export const shortFormatter = new Intl.DateTimeFormat(undefined, {
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  hour12: true,
});

export const getStepUnit = (timeSpan: number): { unit: TimeUnit; stepSize: number } => {
  switch (true) {
    case timeSpan === 7:
      return { unit: 'hour', stepSize: 12 };
    case timeSpan >= 30:
      return { unit: 'week', stepSize: 1 };
    case timeSpan >= 7:
      return { unit: 'day', stepSize: 1 };
    default:
      return { unit: 'hour', stepSize: 1 };
  }
};

export const minutesToHuman = (minutes: number) => `${Math.floor(minutes / 60)}h:${minutes % 60}m`;

export const intervals = [
  { days: 180, label: 'Last 180 Days' },
  { days: 30, label: 'Last 30 Days' },
  { days: 7, label: 'Last 7 Days' },
  { days: 1, label: 'Last 24 Hours' },
];
